var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "run_notice_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        rules: _vm.rules,
        "hide-required-asterisk": "",
      },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v("说明：每个页面只能有一个" + _vm._s(_vm.value.widget)),
      ]),
      _c(
        "el-form-item",
        {
          staticClass: "color-picker",
          attrs: { label: "组件背景色", prop: "background_color" },
        },
        [
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.background_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "background_color", $$v)
              },
              expression: "value.config.background_color",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticClass: "title" }, [_vm._v("文字大小和颜色")]),
          _c(
            "el-form-item",
            { attrs: { label: "字号", prop: "font_size" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 0 },
                model: {
                  value: _vm.value.config.font_size,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "font_size", $$v)
                  },
                  expression: "value.config.font_size",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "颜色", prop: "font_color" } },
            [
              _c("el-color-picker", {
                staticClass: "color-picker",
                model: {
                  value: _vm.value.config.font_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "font_color", $$v)
                  },
                  expression: "value.config.font_color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticClass: "title" }, [_vm._v("通知图标大小和颜色")]),
          _c(
            "el-form-item",
            {
              staticClass: "icon_style",
              attrs: { label: "选择图标", prop: "icon_style" },
            },
            _vm._l(_vm.iconStyleList, function (icon) {
              return _c("i", {
                key: icon,
                class: [
                  "custom-icon",
                  "custom-icon-" + icon,
                  icon === _vm.value.config.icon_style && "checked",
                ],
                on: {
                  click: function ($event) {
                    return _vm.changeIconStyle(icon)
                  },
                },
              })
            }),
            0
          ),
          _c(
            "el-form-item",
            { attrs: { label: "图标尺寸", prop: "icon_size" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 0 },
                model: {
                  value: _vm.value.config.icon_size,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "icon_size", $$v)
                  },
                  expression: "value.config.icon_size",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "颜色", prop: "icon_color" } },
            [
              _c("el-color-picker", {
                staticClass: "color-picker",
                model: {
                  value: _vm.value.config.icon_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "icon_color", $$v)
                  },
                  expression: "value.config.icon_color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "title" }, [
        _vm._v(" 多消息切换样式"),
        _c("span", { staticClass: "sub-title" }, [
          _vm._v("自动播放：上一条滚动完继续播放下一条"),
        ]),
      ]),
      _c(
        "el-form-item",
        { attrs: { prop: "message_change_style" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.message_change_style,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "message_change_style", $$v)
                },
                expression: "value.config.message_change_style",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v("横向滚动（左右滑动切换消息）"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("纵向滚动（上下滑动切换消息）"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "message_speed",
          attrs: { label: "消息播放速度", prop: "message_speed" },
        },
        [
          _c(
            "el-input",
            {
              attrs: { placeholder: "请输入" },
              model: {
                value: _vm.value.config.message_speed,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "message_speed", _vm._n($$v))
                },
                expression: "value.config.message_speed",
              },
            },
            [_c("template", { slot: "append" }, [_vm._v(" 像素/秒 ")])],
            2
          ),
          _c("div", { staticClass: "tips", staticStyle: { margin: "0" } }, [
            _vm._v(" 可自行修改滚动速度（数值越大，速度越快） "),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "title" }, [_vm._v(" 无消息时展示样式 ")]),
      _c(
        "el-form-item",
        { attrs: { prop: "no_message_style" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.no_message_style,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "no_message_style", $$v)
                },
                expression: "value.config.no_message_style",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("整个组件隐藏"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v("默认展示文字"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.value.config.no_message_style === "1"
        ? _c(
            "el-form-item",
            { attrs: { prop: "default_message" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入", clearable: "" },
                model: {
                  value: _vm.value.config.default_message,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "default_message", $$v)
                  },
                  expression: "value.config.default_message",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        { staticClass: "margin_top", attrs: { prop: "margin_top" } },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(" 与上方组件的间距 "),
            _c("span", { staticClass: "sub-title" }, [
              _vm._v(" (当前组件与上一组件的距离，可填入正负整数) "),
            ]),
          ]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "z_index", attrs: { prop: "z_index" } },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(" 层级高度值 "),
            _c("span", { staticClass: "sub-title" }, [
              _vm._v(
                " (模块间如遇重叠，层级数值越大展现级别越高，可填入正整数) "
              ),
            ]),
          ]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }